
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FF4F72","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M5.413 19.216V5.67c0-.92.767-1.67 1.711-1.67h6.6c.944 0 1.712.75 1.712 1.671v2.9a45.739 45.739 0 001.952 2.65l.016-.053.008-.025c.22-.677.303-.979.36-1.356a4.213 4.213 0 00-.02-1.406l-.727-.126-.38-1.41.82-.208-.294-.826-.96-.597.396-.606 1.069.664.15.185.355 1 .145-.037.576 2.16-.385-.067c.06.458.055.924-.016 1.38-.064.427-.155.753-.386 1.467l-.008.024-.08.248c-.03.096-.06.191-.088.287a174.158 174.158 0 00.88 1.096c1.483 1.846 2.113 2.968 2.177 4.402.04.87-.248 1.659-.89 2.063-.58.362-1.368.337-1.994-.017-.528-.298-.936-.8-1.211-1.424-.54-1.215-.538-2.581-.163-4.386.112-.532.242-1.06.39-1.582a61.267 61.267 0 01-1.692-2.223v9.368h1.307V21H4v-1.784h1.413zm0 .719h-.676v.346h11.269v-.346h-.57v.052H5.413v-.052zm.928-.853h8.168V5.672a.777.777 0 00-.785-.767h-6.6a.776.776 0 00-.783.766v13.41zm.785-7.557V6.293h6.597v5.232H7.126zm5.86-.719V7.012H7.863v3.794h5.123zm4.474 2.99c-.348 1.673-.35 2.907.117 3.958.218.492.528.874.905 1.087.399.226.894.242 1.225.034.384-.241.583-.785.553-1.426-.055-1.236-.629-2.258-2.021-3.99a254.226 254.226 0 00-.542-.674 22.51 22.51 0 00-.237 1.012z"}}),_c('path',{attrs:{"d":"M18.848 8.485a3.636 3.636 0 110-7.273 3.636 3.636 0 010 7.273zm.03-6.06a.455.455 0 00-.454.454V5a.455.455 0 00.91 0V2.879a.455.455 0 00-.455-.455zm-.03 4.666a.515.515 0 100-1.03.515.515 0 000 1.03z"}})])])
          )
        }
      }
    